import { render, staticRenderFns } from "./StorySecondary.vue?vue&type=template&id=11396844&scoped=true"
import script from "./StorySecondary.vue?vue&type=script&lang=js"
export * from "./StorySecondary.vue?vue&type=script&lang=js"
import style0 from "./StorySecondary.vue?vue&type=style&index=0&id=11396844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11396844",
  null
  
)

export default component.exports